import { Component } from '@theme/component';

/**
 * @typedef {Object} SiblingsFlavorsNavRefs
 * @property {HTMLElement} list - Scrollable flavor cards container
 * @property {HTMLButtonElement} prevButton - Previous scroll button
 * @property {HTMLButtonElement} nextButton - Next scroll button
 * @property {HTMLElement} [arrowsWrapper] - Arrows container (hidden when no scroll needed)
 */

/** @extends {Component<SiblingsFlavorsNavRefs>} */
class SiblingsFlavorsNav extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.refs.list?.addEventListener('scroll', this.#updateArrows, {
      passive: true,
      signal: this.#controller.signal,
    });
    this.#updateArrows();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  scrollPrev() {
    this.refs.list?.scrollBy({ left: -this.#getScrollAmount() });
  }

  scrollNext() {
    this.refs.list?.scrollBy({ left: this.#getScrollAmount() });
  }

  #getScrollAmount() {
    const card = this.refs.list?.querySelector('.siblings-flavor-card');
    if (!card) return 82;
    const gap = parseInt(getComputedStyle(this.refs.list).gap) || 8;
    return card.offsetWidth + gap;
  }

  #updateArrows = () => {
    const list = this.refs.list;
    if (!list) return;

    const { scrollLeft, scrollWidth, clientWidth } = list;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    const noScroll = scrollWidth <= clientWidth + 1;

    if (this.refs.prevButton) this.refs.prevButton.disabled = atStart;
    if (this.refs.nextButton) this.refs.nextButton.disabled = atEnd;
    if (this.refs.arrowsWrapper) this.refs.arrowsWrapper.hidden = noScroll;
  };
}

if (!customElements.get('siblings-flavors-nav')) {
  customElements.define('siblings-flavors-nav', SiblingsFlavorsNav);
}
